import React from 'react';
import { Link } from 'react-router-dom';

import * as routes from '../../constants/routes';

const SignInLink = ({ children }) =>
  <Link to={routes.SIGN_IN}>{children}</Link>

export default SignInLink;
